module.exports = __webpack_public_path__ + "static/media/8OLA14.787eec63.jpg";